"use strict";

var _interopRequireDefault = require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listEmailConfig = listEmailConfig;
exports.createEmailConfig = createEmailConfig;
exports.updateEmailConfig = updateEmailConfig;
exports.deleteEmailConfig = deleteEmailConfig;
exports.logList = logList;

var _request = _interopRequireDefault(require("@/utils/request"));

function listEmailConfig(query) {
  return (0, _request.default)({
    url: '/emailConfig/list',
    method: 'get'
  });
}

function createEmailConfig(data) {
  return (0, _request.default)({
    url: '/emailConfig/create',
    method: 'post',
    data: data
  });
}

function updateEmailConfig(data) {
  return (0, _request.default)({
    url: '/emailConfig/update',
    method: 'post',
    data: data
  });
}

function deleteEmailConfig(data) {
  return (0, _request.default)({
    url: '/emailConfig/delete',
    method: 'post',
    data: data
  });
}

function logList(query) {
  return (0, _request.default)({
    url: '/emailConfig/logList',
    method: 'get'
  });
}